import {
  SET_DICOM_SELECTION_DATA,
  REMOVE_DICOM_SELECTION_DATA,
  CLEAR_DICOM_SELECTION_DATA
} from '../actions';
import {
  SelectedDicomModel,
  SelectedDicomModelActions
} from '../mappers/SelectedDicomTypesMapper';
import produce, {Draft} from 'immer';

export const initialSelectedDicomState: SelectedDicomModel = {
  selectionData: []
};

export const selectedDicomReducer = produce(
  (state: Draft<SelectedDicomModel>, action: SelectedDicomModelActions) => {
    switch (action.type) {
      case SET_DICOM_SELECTION_DATA:
        // eslint-disable-next-line no-case-declarations
        const listData: any = action.payload?.data;
        state.selectionData = listData;
        break;
      case REMOVE_DICOM_SELECTION_DATA:
        // eslint-disable-next-line no-case-declarations
        const removeIndex: any = action.payload?.data;
        state.selectionData.splice(removeIndex, 1);
        break;
      case CLEAR_DICOM_SELECTION_DATA:
        // eslint-disable-next-line no-case-declarations
        state.selectionData.length = 0;
        break;
      default:
        break;
    }
  },
  initialSelectedDicomState
);
